export const globalInfoHeight = 46;
